import { CheckCircle } from 'lucide-react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const WHATSAPP_NUMBER = '5575981872440';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá, vim do site de nódulo e gostaria de agendar uma consulta com dr. Mateus')}`;

const credentials = [
  'Cirurgião Torácico especializado em Nódulo Pulmonar',
  'Título de Especialista em Cirurgia Torácica emitido pela Sociedade Brasileira de Cirurgia Torácica (SBCT)',
  'Residência em Cirurgia Torácica no Hospital Júlia Kubitschek (Belo Horizonte - MG)',
  'Atua nos melhores hospitais de Feira de Santana - BA',
  'Mais de 500 procedimentos para diagnóstico e tratamento realizados',
  'Trabalho multidisciplinar: oncologistas, pneumologistas e radiologistas',
  'Altíssima taxa de satisfação com abordagem humanizada',
];

export default function NoduloAbout() {
  const [ref, isVisible] = useScrollReveal();
  return (
    <section
      id="sobre"
      ref={ref}
      className={`py-24 md:py-32 bg-white transition-all duration-700 ease-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          <div className="relative flex justify-center">
            <div className="relative w-full max-w-md">
              <img
                src="/images/nodulo_about_photo.jpg"
                alt="Dr. Mateus Marques - Cirurgião Torácico especialista em nódulo pulmonar em Feira de Santana"
                className="w-full h-auto object-contain rounded-3xl shadow-xl"
                loading="lazy"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#0D47A1] text-white rounded-2xl p-5 shadow-xl">
                <div className="font-poppins font-bold text-2xl">500+</div>
                <div className="text-white/75 text-xs font-medium">Procedimentos</div>
              </div>
              <div className="absolute top-6 -left-6 bg-[#00897B] text-white rounded-2xl p-4 shadow-xl hidden lg:block">
                <div className="font-poppins font-bold text-xl">CRM-BA</div>
                <div className="text-white/80 text-xs">28.632</div>
              </div>
            </div>
          </div>

          <div>
            <div className="inline-flex items-center bg-[#00897B]/10 text-[#00897B] rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
              Sobre o Especialista
            </div>
            <h2 className="font-poppins font-bold text-3xl sm:text-4xl text-[#212121] mb-6 leading-tight">
              Em Quem Você Confia<br />para Avaliar Seu Nódulo
            </h2>
            <p className="text-base md:text-lg text-[#212121]/75 leading-relaxed mb-4">
              Dr. Mateus Marques é Cirurgião Torácico especializado em diagnóstico e tratamento de nódulos
              pulmonares, com atuação nos maiores hospitais de Feira de Santana - BA.
            </p>
            <p className="text-base md:text-lg text-[#212121]/75 leading-relaxed mb-4">
              Graduou-se em Medicina pela Escola Bahiana de Medicina e Saúde Pública. Fez residência médica
              em Cirurgia Geral na Santa Casa de Misericórdia da Bahia e concluiu residência em Cirurgia
              Torácica no Hospital Júlia Kubitschek (Belo Horizonte - MG), referência nacional no tratamento
              de doenças torácicas.
            </p>
            <p className="text-base md:text-lg text-[#212121]/75 leading-relaxed mb-8">
              Trabalha em conjunto com pneumologistas e oncologistas, formando uma equipe multidisciplinar
              para conduzir o seu caso com todo o cuidado que você merece. Uma das principais áreas de atuação
              do Dr. Mateus é justamente o acompanhamento, diagnóstico e tratamento de nódulos pulmonares.
            </p>

            <ul className="space-y-3 mb-8">
              {credentials.map((cred, i) => (
                <li key={i} className="flex items-start gap-3">
                  <CheckCircle size={20} className="text-[#00897B] mt-0.5 flex-shrink-0" />
                  <span className="text-[#212121]/80 text-sm md:text-base">{cred}</span>
                </li>
              ))}
            </ul>

            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#0D47A1] text-white font-poppins font-bold px-8 py-4 rounded-full hover:bg-[#00897B] transition-colors duration-200 shadow-lg hover:-translate-y-0.5 hover:shadow-xl"
            >
              AGENDAR CONSULTA COM ESPECIALISTA
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
